export const getSettings = state => state?.features?.settings || {};
export const getError = state => getSettings(state)?.organizations?.error;
export const getIsLoading = state => getSettings(state)?.organizations?.isLoading;
export const getOrganizationById = id => state => getSettings(state)?.organizations?.data?.[id] || {};
export const getOrganizationsAdminDetails = state => getSettings(state)?.admin?.data || {};
export const getAdminOrganizationById = id => state => getSettings(state)?.admin?.data?.[id] || {};
export const getUrlParametersById = id => state => getSettings(state)?.admin?.data?.[id]?.url_params || '';
export const isAdminOrganizationLoading = state => getSettings(state)?.admin?.isLoading;
export const getAdminError = state => getSettings(state)?.admin?.error;
export const getAdminIsLoading = state => getSettings(state)?.admin?.isUpdating;
export const getIsUpdating = state => getSettings(state)?.organizations?.isUpdating;
export const getMarketingIsLoading = state => getSettings(state)?.marketing?.isLoading;
export const getMarketingData = state => getSettings(state)?.marketing?.data || {};
export const getAdminDocumentData = state => getSettings(state)?.document?.data?.documentData || [];
export const getAdminDocumentFiles = state => getSettings(state)?.document?.data?.documentFiles || [];
export const getAdminDocumentIsLoading = state => getSettings(state)?.document?.isLoading;
export const getSubOrgMarketingIsLoading = state => getSettings(state)?.subOrgMarketing?.isLoading;
export const getSubOrgMarketingData = state => getSettings(state)?.subOrgMarketing?.data || {};

export default {
  getError,
  getIsLoading,
  getOrganizationById,
  getIsUpdating,
  getMarketingIsLoading,
  getMarketingData,
  getAdminOrganizationById,
  getAdminError,
  getOrganizationsAdminDetails,
  getSubOrgMarketingIsLoading,
  getSubOrgMarketingData,
};
